<template>
    <el-dialog :append-to-body="true" class="dialog-selector__dialog" :class="{ 'dialog-selector__dialog--single': !multiple }" :title="title" :width="width" @close="handlerCancel"
        :visible="dialogVisible" :close-on-press-escape="false" :close-on-click-modal="false">
        <template v-slot:title>
            <div class="dialog-selector__header">
                <h3 class="dialog-selector__title">{{ title }}</h3>
                <div class="dialog-selector__search" v-if="showSearch">
                    <div class="dialog-selector__search_input">
                        <el-input
                            size="small"
                            prefix-icon="el-icon-search"
                            :placeholder="searchPlaceholder"
                            clearable
                            v-model="searchVmKeyword"
                            @keyup.native.enter="onSelectSearchResult">
                        </el-input>
                    </div>
                </div>
            </div>
        </template>
        <template>
            <slot name="tip"></slot>
        </template>
        <div class="dialog-selector" v-loading="loading">
            <div class="dialog-selector__sidebar" v-if="showSidebar">
                <ul class="dialog-selector__menu-list">
                    <li class="dialog-selector__menu-item"
                        v-for="(item, index) in sidebarList"
                        @click="onClickMenuItem(item)"
                        :key="index"
                        :title="item[groupProps.label]"
                        :class="{'active': item[groupProps.id] === selectMenuId}">
                        <slot name="sidebarItem" :menu-item="item">
                            <span>{{ item[groupProps.label] | cutString(12) }}</span>
                        </slot>
                    </li>
                </ul>
            </div>
            <div class="dialog-selector__main">
                <p class="dialog-selector__search_tips" v-if="searchVmKeyword && viewDataCount > 0">
                    查询到<span>{{ viewDataCount }}</span>条结果
                </p>
                <slot name="selectoption"></slot>
                <div class="dialog-selector__content" ref="selectorContent" @scroll="onContentScroll">
                    <el-collapse v-model="collapseIndexList">
                        <el-collapse-item 
                            :disabled="disabledCollapse"
                            v-for="(item, index) in viewData"
                            :key="index"
                            :title="item[contentProps.label]"
                            :name="index">
                            <template v-slot:title>
                                <div class="dialog-selector__group-header" :id="`group-${item[groupProps.id]}`">
                                    <am-icon class="group-header__icon" :class="{'is-expand': collapseIndexList.includes(index)}" name="caret-right" is-element></am-icon>
                                    <el-checkbox
                                        v-if="multiple && allButtonVisible"
                                        :key="item[contentProps.id]"
                                        :disabled="disabledSelectAll"
                                        :indeterminate="groupSelectMapData[item[contentProps.id]].isIndeterminate"
                                        v-model="groupSelectMapData[item[contentProps.id]].checkAll" @change="value => handleCheckedGroup(value, item)">
                                        <span>{{ item[contentProps.label] }}</span>
                                    </el-checkbox>
                                    <span v-else>{{ item[contentProps.label] }}</span>
                                </div>
                            </template>
                            <el-checkbox-group v-if="multiple" v-model="selectIds" @change="handleCheckedChange">
                                <div class="dialog-selector__group">
                                    <el-checkbox class="dialog-selector__item" 
                                        v-for="child in item[contentProps.children]"
                                        :disabled="setDisabledSelectChild(child)"
                                        :border="checkboxBorder"
                                        :label="child[contentProps.id]"
                                        :key="child[contentProps.id]">
                                        <slot name="node" :node="child">
                                            {{child[contentProps.label]}}
                                        </slot>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                            <div class="dialog-selector__group" v-else>
                                <div 
                                    v-for="child in item[contentProps.children]"
                                    class="dialog-selector__item"
                                    :class="{ 'selected': child[contentProps.id] === selectId }"
                                    :key="child[contentProps.id]"
                                    @click="onSelectItem(child)">
                                   <slot name="node" :node="child">
                                        {{child[contentProps.label]}}
                                    </slot>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                    <div class="dialog-selector__empty" v-if="!viewDataCount">
                        <slot name="empty">暂无数据</slot>
                    </div>
                </div>
                <div class="dialog-selector__footer" v-if="multiple">
                    <div class="dialog-selector__shortcut">
                        <slot name="shortcut"></slot>
                    </div>
                    <div class="dialog-selector__buttons">
                        <el-button size="medium" @click="handlerCancel">取消</el-button>
                        <el-button size="medium" @click="handlerConfirm" type="primary">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import AmIcon from '@/components/icon'
    import UtilsMixins from '@/mixins/utils'
    export default {
        name: 'AsDialogSelector',
        components: {
            AmIcon
        },
        mixins: [UtilsMixins],
        props: {
            loading: Boolean,
            value: Boolean,
            showSidebar: {
                type: Boolean,
                default: true
            },
            disabledCollapse: {
                type: Boolean,
                default: false
            },
            allButtonVisible: {
                type: Boolean,
                default: true
            },
            checkboxBorder: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: '请选择',
            },
            sidebarList: Array,
            sidebarProps: Object,
            data: {
                type: Array,
                default: () => []
            },
            filterNodeMethod: Function,
            width: {
                type: String,
                default: '762px'
            },
            searchPlaceholder: {
                type: String,
                default: '请输入搜索关键字'
            },
            showSearch: {
                type: Boolean,
                default: true
            },
            props: Object,
            defaultCheckedKeys: Array,
            multiple: {
                type: Boolean,
                default: true
            },
            selectId: [Number, String],
            disabledSelectAll: Boolean,
            beforeConfirm: Function,
            disabledSelectChildFun: {
                type: Function,
                default: () => { return false }
            },
        },
        data() {
            return {
                selectIds: [],
                collapseIndexList: [],
                dialogVisible: false,
                searchVmKeyword: '',
                selectMenuId: null,
                groupSelectMapData: {},
                viewData: []
            }
        },
        watch: {
            value(newVal) {
                this.dialogVisible = newVal;
                if (newVal)  {
                    this.selectIds = this.defaultCheckedKeys || []
                    this.searchVmKeyword = '';
                    this.filter();
                }
            },
            data: {
                handler() {
                    if (!this.data) return;
                    const collapseIndexList = [];
                    const { id } = this.contentProps;
                    const groupSelectMapData = {};
                    this.data.forEach((groupData, index) => {
                        collapseIndexList.push(index);
                        groupSelectMapData[groupData[id]] = {
                            selectIds: [],
                            isIndeterminate: false,
                            checkAll: false,
                        }
                    })
                    this.groupSelectMapData = groupSelectMapData;
                    this.collapseIndexList = collapseIndexList;
                    this.filter();
                    this.$nextTick(() => {
                        this.handleCheckedChange(this.selectIds);
                    })
                },
                immediate: true,
            },
            sidebarList: {
                handler() {
                    if (!this.sidebarList || !this.showSidebar) return;
                    this.onClickMenuItem(this.sidebarList[0]);
                },
                immediate: true,
            },
            defaultCheckedKeys: {
                handler(newVal) {
                    this.selectIds = newVal || [];
                    this.$nextTick(() => {
                        this.handleCheckedChange(this.selectIds);
                    })
                },
                immediate: true,
                deep: true
            },
            searchVmKeyword(newVal, oldValue) {
                if (newVal !== oldValue) {
                    this.$emit('search-key-change', newVal);
                }
                if (newVal) {
                    this.selectMenuId = null;
                } else if (!this.selectMenuId && this.showSidebar) {
                    this.onClickMenuItem(this.sidebarList[0]);
                }
                this.filter(newVal);
            },
        },
        computed: {
            viewDataCount() {
                return this.viewData.reduce((total, groupData) => {
                    return total += groupData[this.contentProps.children].length;
                }, 0)
            },
            mapData() {
                let mapData = {};
                if (!this.data) return mapData;
                this.data.forEach(groupData => {
                    groupData[this.contentProps.children].forEach(childData => {
                        const id = childData[this.contentProps.id]
                        mapData[id] = childData;
                    })
                });
                return mapData;
            },
            groupMapData() {
                let mapData = {};
                const { id, children } = this.contentProps;
                if (!this.data) return mapData;
                this.data.forEach(groupData => {
                    const groupId = groupData[id];
                    const childrenData = groupData[children];
                    mapData[groupId] = childrenData;
                })
                return mapData;
            },
            contentProps() {
                return Object.assign({}, { label: 'label', id: 'id', children: 'children', groupId: 'groupId'  }, this.props || {});
            },
            groupProps() {
                return Object.assign({ label: 'label', id: 'id' }, this.props, this.sidebarProps || {});
            },
        },
        methods: {
            onContentScroll(e) {
                this.$emit('content-scroll', e);
            },
            setCheckedKeys(value) {
                this.selectIds = value;
                this.handleCheckedChange(this.selectIds);
            },
            onSelectSearchResult() {
                if (!this.searchVmKeyword || !this.multiple) return;
                const { children, id } = this.contentProps;
                const idList = this.viewData.reduce((idList, groupData) => {
                    const groupChildren = groupData[children];
                    const ids = groupChildren.map(item => item[id]);
                    return idList.concat(ids);
                }, [])
                this.selectIds = [...new Set(this.selectIds.concat(idList))];
                this.handleCheckedChange(this.selectIds);
            },
            handleCheckedGroup(value, item) {
                const { id, children, } = this.contentProps;
                const groupId = item[id];
                const groupChildren = item[children]; 
                this.groupSelectMapData[groupId].isIndeterminate = false;
                this.groupSelectMapData[groupId].checkAll = value;
                this.groupSelectMapData[groupId].selectIds = [];
                const idList = groupChildren.map(item => item[id]);
                if (value) {
                    this.groupSelectMapData[groupId].selectIds = idList;
                    this.selectIds = [...new Set(this.selectIds.concat(idList))];
                } else {
                    this.selectIds = this.selectIds.filter(id => !idList.includes(id));
                    this.groupSelectMapData[groupId].selectIds = [];
                }
                this.$emit('select-change', this.groupSelectMapData);
            },
            handleCheckedChange(value) {
                let groupSelectMapData = this.groupSelectMapData;
                for (let id in groupSelectMapData) {
                    groupSelectMapData[id].selectIds = [];
                }
                value.forEach(id => {
                    const data = this.mapData[id];
                    if (data) {
                        const groupId = data[this.contentProps.groupId];
                        if (groupSelectMapData[groupId]) {
                            groupSelectMapData[groupId].selectIds.push(id)
                        } else {
                            groupSelectMapData[groupId] = {
                                selectIds: [],
                                isIndeterminate: false,
                                checkAll: false,
                            }
                        }
                    }
                })
                for (let id in groupSelectMapData) {
                    const groupChildren = this.groupMapData[id];
                    if (!groupChildren) return;
                    const currentGroupData = groupSelectMapData[id];
                    const { selectIds } = currentGroupData;
                    currentGroupData.checkAll = groupChildren.length === selectIds.length;
                    currentGroupData.isIndeterminate = !currentGroupData.checkAll && selectIds.length > 0;
                }
                this.groupSelectMapData = groupSelectMapData;
                this.$emit('select-change', this.groupSelectMapData);
            },
            filter(searchVmKeyword) {
                const { children, label } = this.contentProps;
                const filterNodeMethod = this.filterNodeMethod || function (searchVmKeyword, node) {
                    const nodeLabel = node[label];
                    return !searchVmKeyword || nodeLabel.includes(searchVmKeyword);
                }
                if (!this.data) return [];
                this.viewData = this.data.map(item => JSON.parse(JSON.stringify(item))).filter(item => {
                    item[children] = item[children].filter(childItem => filterNodeMethod(searchVmKeyword, childItem));
                    return item[children].length > 0;
                })
            },
            // 取消操作
            handlerCancel() {
                this.$emit("on-cancel");
                this.handleDialogClose();
            },
            handleDialogClose() {
                this.dialogVisible = false;
                this.$emit('input', false);
            },
            // 确认操作
            handlerConfirm() {
                const checkNodes = this.selectIds.map(id => this.mapData[id]).filter(item => item);
                if(this.beforeConfirm && this.beforeConfirm(checkNodes) === false) {
                    return;
                }
                this.$emit('on-confirm', checkNodes);
                this.handleDialogClose();
            },
            onClickMenuItem(menuItem) {
                this.searchVmKeyword = '';
                this.selectMenuId = menuItem[this.groupProps.id];
                this.$emit('click-sidebar-item', menuItem, {
                    contentDOM: this.$refs.selectorContent,
                });
            },
            onSelectItem(data) {
                this.$emit('on-select-item', data);
                this.handleDialogClose();
            },
            setSelectMenuById(id) {
                this.selectMenuId = id;
                this.filter();
            },
            setDisabledSelectChild(child) {
                let flag = this.disabledSelectChildFun(child)
                return flag
            } 
        },
        mounted() {
            this.dialogVisible = this.value;
        }
    }
</script>

<style lang="scss">
    .dialog-selector__dialog {
        & .el-dialog__body {
			padding: 0;
		}
        .el-dialog__headerbtn {
            right: 14px;
            top: 14px;
            .el-dialog__close {
                color: #000;
            }
        }
        .el-dialog__header {
            padding: 8px 18px;
            border-bottom: 1px solid #DCDFE6;
        }
        .dialog-selector__title {
            padding-right: 20px;
            font-size: 13px;
            color: #333;
            font-weight: 700;
        }
        .el-collapse-item__header {
            height: auto;
            line-height: 1.3;
            font-size: 13px;
            font-weight: 700;
            border-bottom: none;
            margin-top: 15px;
            .el-collapse-item__arrow {
                display: none;
            }
            &:hover{
                background-color: #f5f7fa;
                transition: all .3s;
            }
        }
        .el-collapse-item__content {
            line-height: inherit;
            padding: 0;
        }
        .el-collapse-item__wrap {
            border-bottom: none;
        }
        .el-collapse {
            border: none;
        }
        .el-checkbox {
            display: flex;
            align-items: center;
        }
        .el-checkbox__input {
            width: 14px;
            height: 14px;
        }
        .el-checkbox__label {
            flex: 1;
            font-size: 12px;
        }
        .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #333;
        }
        &.dialog-selector__dialog--single {
            .dialog-selector__item {
                padding-left: 5px;
                transition: all .3s;
                line-height: 1.8;
                &:hover,
                &.selected{
                    background-color: #f5f7fa;
                    transition: all .3s;
                }
            }
            .dialog-selector__content {
                height: 363px;
            }
            .dialog-selector__group {
                padding-left: 15px;
            }
        }
        .el-collapse-item:first-child {
            .el-collapse-item__header {
                margin-top: 0;
            }
        }
        .el-collapse-item.is-disabled .el-collapse-item__header {
            color: #333;
            cursor: default;
        }
    }
    .dialog-selector {
        display: flex;
    }
    .dialog-selector__header {
        width: 100%;
        display: flex;
        align-items: center;
    }
    .dialog-selector__sidebar {
        flex: 0 0 142px;
    }

    .dialog-selector__menu-list {
        padding: 0;
        margin: 0;
        height: 453px;
        overflow: hidden auto;
        background: #F9FBFF;
    }

    .dialog-selector__menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 40px;
        width: 100%;
        padding-left: 15px;
        padding-right: 7px;
        font-size: 13px;
        color: #333;
        cursor: pointer;
        &.active {
            background: #fff;
            color: #409EFF;
			font-weight: bold;
        }
        .el-badge {
            width: 100%;
        }
        .el-badge__content.is-fixed {
            transform: none;
            top: none;
            right: 0;
        }
    }

    .dialog-selector__main {
        position: relative;
        flex: 1;
        padding: 0 10px 15px;
    }

    .dialog-selector__search {
        position: relative;
    }

    .dialog-selector__search_input {
        padding-left: 10px;
        width: 350px;
        .el-input__inner {
            border: none;
            font-size: 12px;
            &::placeholder {
                color: #909090;
            }
        }
        &:before {
            content: "";
            position: absolute;
            z-index: 2;
            width: 1px;
            height: 18px;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            background-color: #D8D8D8;
        }
        .el-input__prefix {
            color: #909090;
        }
    }

    .dialog-selector__search_tips {
        position: absolute;
        left: 15px;
        line-height: 2;
        color: #909090;
        font-size: 12px;
        & span {
            color: #222;
            padding: 0 3px;
        }
    }

    .dialog-selector__content {
        position: relative;
        height: 315px;
        overflow-y: auto;
        margin: 24px 0 6px;
    }
    .dialog-selector__empty {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        padding-top: 23px;
        text-align: center;
        background: #fff;
        color: #909090;
    }

    .dialog-selector__group-header {
        display: flex;
        align-items: center;
        .el-checkbox__label{
            font-weight: 700;
            font-size: 13px;
            color: #333;
        }
        .group-header__icon {
            margin-right: 7px;
            transition: transform .3s;
            color: #909090;
            &.is-expand {
                transform: rotate(90deg);
                transition: transform .3s;
            }
        }
    }

    .dialog-selector__group {
        display: flex;
        flex-wrap: wrap;
        margin-top: 14px;
        padding-left: 21px;
    }
    .dialog-selector__item {
        display: flex;
        align-items: center;
        margin: 0 0 13px 0;
        padding-right: 15px;
        flex: 0 0 25%;
        font-size: 12px;
        font-weight: normal;
        line-height: 1.2;
        color: #333;
        cursor: pointer;
        &:hover {
            background-color: #f5f7fa;
            transition: all .3s;
        }
    }

    .dialog-selector__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 15px;
        text-align: right;
        border-top: 1px solid #DCDFE6;
    }
    @media only screen and (max-height: 600px) {
        .dialog-selector__menu-list {
            height: 330px !important;
        }
        .dialog-selector__dialog.dialog-selector__dialog--single .dialog-selector__content{
            height: 300px !important;
        }
    }
</style>